import ServerStack from "public/openStack/deployment/fa6-solid_server.png";
import CloudVector from "public/openStack/deployment/cloud_vector.png";
import RecoveryVector from "public/openStack/deployment/wpf_refresh-shield.png";

export const DEPLOYMENT_CONSTANTS = [
  {
    image: ServerStack,
    title: "Bare Metal Hosting",
    text: "In OneMind Data Centers",
  },
  {
    image: CloudVector,
    title: "Hybrid Cloud",
    text: "With public cloud bursting",
  },
  {
    image: RecoveryVector,
    title: "Disaster Recovery",
    text: "Multi-site HA available",
  },
];
